// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/navigation/DropdownNav.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/navigation/DropdownNav.tsx");
  import.meta.hot.lastModified = "1717182690457.8184";
}
// REMIX HMR END

import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Link from "~/components/Link";
import IconResolver from "../IconResolver";
import clsx from "clsx";
export default function DropdownNav({
  title,
  items
}) {
  return <Menu as="nav" className="relative inline-block text-left">
      {({
      open
    }) => <Fragment>
          <Menu.Button className={clsx("flex justify-center items-center hover:text-secondary-200 duration-300", open ? "text-secondary-200" : "text-neutral-100")}>
            {title}
            <IconResolver token="chevron-down" className={clsx("w-4.5 h-4.5 ml-1 transition-transform duration-200", open && "transform rotate-180")} />
          </Menu.Button>
          <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
            <Menu.Items className="flex flex-col absolute left-0 mt-4 w-56 divide-y divide-primary-500 border-t-2 border-t-secondary-500 bg-primary-800 rounded-b-[10px] shadow-xl">
              {items.map(({
            title,
            url
          }) => <Menu.Item key={title}>
                  <Link prefetch="intent" to={url} className="block w-full pl-4 py-5" theme="dark">
                    {title}
                  </Link>
                </Menu.Item>)}
            </Menu.Items>
          </Transition>
        </Fragment>}
    </Menu>;
}
_c = DropdownNav;
var _c;
$RefreshReg$(_c, "DropdownNav");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;